import { ReactElement, ReactNode } from "react";
import {
  PassSettingDescription,
  PassSettingRow,
  PassSettingSection,
  PassSettingText,
  PassSettingTitle,
} from "./passSettingsV2.styled";

interface SystemSettingRowProps {
  children: ReactNode;
  controlVerticalAlign?: "center" | "start";
  description?: string;
  title: string;
}

export const SystemSettingRow = (
  props: SystemSettingRowProps,
): ReactElement => {
  return (
    <PassSettingSection>
      <PassSettingRow $controlVerticalAlign={props.controlVerticalAlign}>
        <PassSettingText>
          <PassSettingTitle>{props.title}</PassSettingTitle>
          {props.description ? (
            <PassSettingDescription>{props.description}</PassSettingDescription>
          ) : null}
        </PassSettingText>
        {props.children}
      </PassSettingRow>
    </PassSettingSection>
  );
};
